import { Item } from 'components/CollabItem/Item'
import { useRootStore } from '../../stores/RootStore'
import { Comment } from 'types'
import { DeleteButton } from './DeleteButton'

interface Props {
  comment: Comment
}

export const DeleteCommentControl = ({ comment }: Props) => {
  const rootStore = useRootStore()
  const resolveComment = () => rootStore.comments.delete(comment.id, { trackArticleUpdate: true })

  return (
    <Item.Control>
      <DeleteButton onPress={resolveComment} />
    </Item.Control>
  )
}
